import apiInternal from '@services/axios-internal';
import { Track } from '../models/track';

export const apiCreateTrack = async (track: Track): Promise<boolean> =>
  apiInternal.post('/api/track', track);
